package br.com.htms.inspeccaocampo.data

enum class FormTipo(val id: String, val rotulo: String, val rotuloCurto: String) {
    INSPECAO_CAMPO(
        id = "INSPECAO_CAMPO",
        rotulo = "Inspeção de Campo Diária",
        rotuloCurto = "Inspeção"
    ),
    CHECKLIST_DIARIO_HTMS(
        id = "CHECKLIST_DIARIO_HTMS",
        rotulo = "Inspeção HTMS",
        rotuloCurto = "HTMS"
    ),
    CHECKLIST_DIARIO_AXIA(
        id = "CHECKLIST_DIARIO_AXIA",
        rotulo = "Inspeção Axia",
        rotuloCurto = "Axia"
    ),
    RELATORIO_FOTO_ALOJAMENTO(
        id = "RELATORIO_FOTO_ALOJAMENTO",
        rotulo = "Relatório Fotográfico-Alojamento",
        rotuloCurto = "Rel. Foto"
    ),
    CHECKLIST_ALOJAMENTO(
        id = "CHECKLIST_ALOJAMENTO",
        rotulo = "Checklist - Alojamento",
        rotuloCurto = "Checklist"
    ),
    CHECKLIST_VETORES(
        id = "CHECKLIST_VETORES",
        rotulo = "Controle de vetores",
        rotuloCurto = "Vetores"
    ),
    RELATORIO_ALOJAMENTO(
        id = "RELATORIO_ALOJAMENTO",
        rotulo = "Relatório Alojamento",
        rotuloCurto = "Rel. Aloj."
    ),
    COMUNICACAO_OCORRENCIAS(
        id = "COMUNICACAO_OCORRENCIAS",
        rotulo = "Comunicação Prévia de ocorrências",
        rotuloCurto = "Ocorrências"
    ),
    REM_SEGURANCA_OBRAS(
        id = "REM_SEGURANCA_OBRAS",
        rotulo = "REM Segurança — Obras",
        rotuloCurto = "REM"
    ),
    RELATORIO_SEGURANCA(
        id = "RELATORIO_SEGURANCA",
        rotulo = "Relatório de segurança",
        rotuloCurto = "Rel. Seg."
    ),
    ACOMPANHAMENTO_AMBIENTAL(
        id = "ACOMPANHAMENTO_AMBIENTAL",
        rotulo = "Acompanhamento Ambiental",
        rotuloCurto = "Acomp. Amb."
    ),
    EVIDENCIA_TREINAMENTO(
        id = "EVIDENCIA_TREINAMENTO",
        rotulo = "Evidência de Treinamento",
        rotuloCurto = "Treinamento"
    ),
    ANALISE_VISUAL_NR(
        id = "ANALISE_VISUAL_NR",
        rotulo = "Analise visual de cena (IA)",
        rotuloCurto = "NRs IA"
    );

    companion object {
        /**
         * Pausado: não aparece no hub/config. Código e Worker ficam;
         * reative com `true` quando retomar a feature de IA.
         */
        const val ANALISE_VISUAL_NR_ATIVA = false

        fun fromId(raw: String?): FormTipo =
            entries.find { it.id.equals(raw, ignoreCase = true) } ?: INSPECAO_CAMPO

        /** Formulários exibidos no hub inicial. */
        val hubEntries: List<FormTipo> = buildList {
            add(INSPECAO_CAMPO)
            add(CHECKLIST_DIARIO_HTMS)
            add(CHECKLIST_DIARIO_AXIA)
            add(RELATORIO_ALOJAMENTO)
            add(CHECKLIST_VETORES)
            add(COMUNICACAO_OCORRENCIAS)
            add(REM_SEGURANCA_OBRAS)
            add(RELATORIO_SEGURANCA)
            add(ACOMPANHAMENTO_AMBIENTAL)
            add(EVIDENCIA_TREINAMENTO)
            if (ANALISE_VISUAL_NR_ATIVA) add(ANALISE_VISUAL_NR)
        }
    }
}

/** C / NC / NA — mesma lógica ternária; checklist usa C/NC/NA, relatório foto usa Sim/Não/N/A. */
enum class RespostaConformidade(val codigo: String, val rotulo: String) {
    C("C", "Conforme"),
    NC("NC", "Não conforme"),
    NA("NA", "Não se aplica");

    /** Rótulo Sim / Não / N/A (Relatório Fotográfico). */
    val rotuloSimNao: String
        get() = when (this) {
            C -> "Sim"
            NC -> "Não"
            NA -> "N/A"
        }

    companion object {
        const val LEGENDA = "C - CONFORME    NC - NÃO CONFORME    NA - NÃO APLICÁVEL"
        const val LEGENDA_SIM_NAO = "Sim / Não / N/A"

        fun fromName(raw: String?): RespostaConformidade? =
            raw?.takeIf { it.isNotBlank() }?.let { runCatching { valueOf(it) }.getOrNull() }
    }
}

enum class TipoCampoExtra {
    NENHUM,
    NUMERO,
    TEXTO
}

data class ItemConformidade(
    val id: String,
    val numero: String,
    val titulo: String,
    val secao: String,
    val resposta: RespostaConformidade? = null,
    val fotos: List<FotoAnexo> = emptyList(),
    val justificativa: String = "",
    val valorExtra: String = "",
    val tipoExtra: TipoCampoExtra = TipoCampoExtra.NENHUM,
    val labelExtra: String = "",
    val fotoHabilitada: Boolean = true,
    val fotoObrigatoria: Boolean = true,
    val obrigatorio: Boolean = true
) {
    val tituloNumerado: String
        get() = if (numero.isBlank()) titulo else "$numero $titulo"
}

data class SecaoConformidade(
    val titulo: String,
    val itens: List<ItemConformidade>
)
